import img1 from "../assets/lisa/1.jpg"
import img2 from "../assets/lisa/2.jpg"
import img3 from "../assets/lisa/3.jpg"
import img4 from "../assets/lisa/4.jpg"
import img5 from "../assets/lisa/5.jpg"
import img6 from "../assets/lisa/6.jpg"
import img8 from "../assets/lisa/8.jpg"
import img9 from "../assets/lisa/9.png"
import img15 from "../assets/lisa/15.jpg"
import img17 from "../assets/lisa/17.jpg"
import img16 from "../assets/lisa/16.jpg"
import img18 from "../assets/lisa/18.png"
import img19 from "../assets/lisa/19.jpg"
import img20 from "../assets/lisa/20.jpg"
import img21 from "../assets/lisa/21.jpg"
import img22 from "../assets/lisa/22.jpg"
import img23 from "../assets/lisa/23.jpg"
import img24 from "../assets/lisa/24.jpg"
import img25 from "../assets/lisa/25.jpg"
import img26 from "../assets/lisa/26.jpg"
import img27 from "../assets/lisa/27.jpg"
import img28 from "../assets/lisa/28.png"
import img29 from "../assets/lisa/29.jpg"
import img30 from "../assets/lisa/30.jpg"
const LisaImages = [
   img1,
   img2, img3, img4, img5, img6, img8, img9,
   img15, img16, img17, img18, img19, img20,
   img21, img22, img23, img24, img25, img26, img27,
   img28, img29, img30
   
]
export default LisaImages